import src from "IMAGE";
export default { src, width: 155, height: 32, blurWidth: 0, blurHeight: 0};
